import gql from "graphql-tag";

export const GET_PROJECT_ARTIFACT_UPLOAD_URL = gql`
  query ($projectId: Float!, $artifactType: String!, $filename: String!) {
    getProjectArtifactUploadUrl(
      projectId: $projectId
      artifactType: $artifactType
      filename: $filename
    )
  }
`;

export const GET_PROJECT_ARTIFACT_DOWNLOAD_URL = gql`
  query (
    $projectId: Float!
    $artifactType: String!
    $filename: String!
    $quality: String
  ) {
    getProjectArtifactDownloadUrl(
      projectId: $projectId
      artifactType: $artifactType
      filename: $filename
      quality: $quality
    )
  }
`;

export const GET_PROJECT_ARTIFACT_MULTIPART_INFO = gql`
  query (
    $projectId: Float!
    $artifactType: String!
    $filename: String!
    $numberOfParts: Float!
  ) {
    getProjectArtifactMultipartInfo(
      projectId: $projectId
      artifactType: $artifactType
      filename: $filename
      numberOfParts: $numberOfParts
    ) {
      filename
      uploadId
      parts {
        partNumber
        eTag
        signedUrl
      }
    }
  }
`;

export const COMPLETE_PROJECT_ARTIFACT_MULTIPART = gql`
  mutation (
    $projectId: Float!
    $artifactType: String!
    $filename: String!
    $uploadId: String!
    $eTags: String!
  ) {
    completeProjectArtifactMultipart(
      projectId: $projectId
      artifactType: $artifactType
      filename: $filename
      uploadId: $uploadId
      eTags: $eTags
    )
  }
`;

export const REGISTER_PROJECT_ARTIFACT = gql`
  mutation (
    $projectId: Float!
    $name: String!
    $artifactType: String!
    $filename: String!
    $fileSize: Float
    $mimeType: String
    $metadata: String
  ) {
    registerProjectArtifact(
      projectId: $projectId
      name: $name
      artifactType: $artifactType
      filename: $filename
      fileSize: $fileSize
      mimeType: $mimeType
      metadata: $metadata
    ) {
      id
      name
      artifactType
      s3Key
      fileSize
      mimeType
      metadata
      created
      lastModified
    }
  }
`;

export const PROJECT_ARTIFACTS_FOR_PROJECT = gql`
  query ($projectId: Float!, $artifactType: String) {
    projectArtifactsForProject(
      projectId: $projectId
      artifactType: $artifactType
    ) {
      id
      name
      artifactType
      s3Key
      fileSize
      mimeType
      metadata
      created
      lastModified
    }
  }
`;

export const DELETE_PROJECT_ARTIFACT = gql`
  mutation ($id: Float!) {
    deleteProjectArtifact(id: $id)
  }
`;
